<template>
    <v-bottom-navigation
        v-model="currentMenu"
        grow
        color="primary"
        style="box-shadow: none; border-top: 1px #ddd solid"
    >
        <v-btn :to="{ name: 'bank' }" v-if="enableBank" value="bank">
            <v-icon>$oss-bank</v-icon>
            <span>{{ $t("menu.bank") }}</span>
        </v-btn>
        <v-btn value="documents" :to="{ name: 'documents' }" v-if="userConfig.document.read">
            <v-icon>$oss-archives</v-icon>
            <span>{{ $t("menu.documents") }}</span>
        </v-btn>
        <v-btn
            :to="{ name: 'expenseReports' }"
            value="expenseReports"
            v-if="userConfig.expenseReport.read"
        >
            <v-icon>$oss-expense-report</v-icon>
            <span>{{ $t("menu.expenseReportsLight") }}</span>
        </v-btn>
        <v-btn value="dashboard" :to="{ name: 'dashboard' }" v-if="userConfig.business.dashboard">
            <v-icon>$oss-dashboard</v-icon>
            <span>{{ $t("menu.dashboard") }}</span>
        </v-btn>
    </v-bottom-navigation>
</template>
<script lang="ts">
import { Component, Vue, toNative, Watch, Prop, Model } from "vue-facing-decorator";
import { User } from "@/store/store";
import { ProfileConfiguration } from "../../../../backend/src/common/profile/profile";

@Component
class MobileBottomNavigation extends Vue {
    @Model({ type: String }) currentMenu: string;
    @Prop({ default: null, type: User }) currentUser: User;
    @Prop({ default: null }) userConfig: ProfileConfiguration;

    get enableBank() {
        return (
            this.userConfig.bankTransaction.read &&
            (!this.currentUser.companyUser || !this.currentUser.companyUser?.accessRights.length)
        );
    }
}

export default toNative(MobileBottomNavigation);
</script>
